var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0C14.3265 0 0 14.3265 0 32C0 49.6735 14.3265 64 32 64C49.6735 64 64 49.6735 64 32C64 14.3265 49.6735 0 32 0Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1396 15.2H51.925L39.8885 27.1121C35.5314 31.4242 28.4673 31.4242 24.1102 27.1121L12.0737 15.2H17.8591L27.0029 24.2494C29.7623 26.9803 34.2362 26.9803 36.9958 24.2494L46.1396 15.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7854 48.325H12L24.1109 36.3393C28.4679 32.0272 35.532 32.0272 39.8891 36.3393L52 48.325H46.2146L36.9963 39.202C34.2369 36.471 29.763 36.471 27.0035 39.202L17.7854 48.325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.2807fba845a139cbb286723ac27ed2a5.svg";
export { ForwardRef as ReactComponent };